import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getCommodity,
  addCommodity,
  updateCommodity,
} from "../../../common/services/products/commodityService";
import { getCommodityClasses } from "../../../common/services/products/commodityClassService";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import CommodityHistory from "./commodityHistory";
import QualityAttributeCommodity from "./qualityAttributeCommodity";
import { withTranslation } from "react-i18next";

class Commodity extends Form {
  state = {
    data: {
      commodityId: "",
      name: "",
      description: "",
      commodityClassId: "",
      active: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    commodityClasses: [],
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    commodityId: Joi.string(),
    name: Joi.string().required().label(this.props.t("CommodityName")),
    description: Joi.string().label(this.props.t("CommodityDescription")),
    commodityClassId: Joi.string()
      .required()
      .label(this.props.t("CommodityClass")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    //try{
    const { commodityId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var commodity = {};

    if (!isNew) {
      commodity = await getCommodity(commodityId);
      commodity.eventId = uuid();
    } //New User Add
    else {
      commodity = {
        commodityId: commodityId,
        name: "",
        description: "",
        commoditiyClassId: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({ data: this.mapToViewModel(commodity), isLoading: false });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(commodity.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(commodity.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });

    this.setState({ commodityClasses: (await getCommodityClasses()).filter(x => x.active || x.commodityClassId === commodity.commoditiyClassId) });

    // }
    // catch(ex)
    // {
    //     //Handle Erorr..
    // }
  }

  mapToViewModel(commodity) {
    return {
      commodityId: commodity.commodityId,
      name: commodity.name,
      description: commodity.description,
      commodityClassId: commodity.commodityClassId,
      active: commodity.active,
      eventId: commodity.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      //Reset the event ID
      const data = { ...this.state.data };
      data.eventId = uuid();
      this.setState({ data: data });

      if (!isNew) {
        await updateCommodity(this.state.data);
        toast.success(t("CommodityUpdated"));
      } else {
        await addCommodity(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.commodityId, this.state.data.name);
        toast.success(t("CommodityAdded"));
      }

      //Call back to the select list to allow it to update.
      this.props.submitCallbackFunction(this.state.data);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;              
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate } =
      this.state;

    if (isLoading) return <Loading />;

    const { t, commodityId, allowEdit } = this.props;

    return (
      <div className="container-fluid">
        <form
          
          className="form-inline"
          onSubmit={this.handleSubmit}
        >
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {this.renderInput("name", t("CommodityName"))}
              {this.renderInput("description", t("CommodityDescription"))}
              {this.renderSelect(
                "commodityClassId",
                t("CommodityClass"),
                this.state.commodityClasses,
                "commodityClassId"
              )}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={1}
              id="useraccount-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              <Tab eventKey={1} title={t("QualityAttributes")}>
                <QualityAttributeCommodity
                  commodityId={commodityId}
                  allowEdit={allowEdit}
                />
              </Tab>
              <Tab eventKey={2} title={t("History")}>
                <CommodityHistory commodityId={commodityId} />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["products"])(Commodity);
